import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SnackbarUtils from "../../libs/SnackbarUtils";
import {
  serviceDoctorEnrollTrendExport,
  serviceDoctorMedicineTrendExport,
  serviceGetDoctorDashboardDrop,
  serviceGetDoctorDashboardMedReminder,
  serviceGetDoctorDashboardMedicineRefill,
  serviceGetDoctorDashboardReward,
  // serviceGetDoctorDashboardEnrollment,
  serviceGetDoctorDashboardTable,
} from "../../services/DoctorDashboard.service";
import history from "../../libs/history.utils";
import RouteName from "../../routes/Route.name";
import moment from "moment";
import { updateForm, resetForm } from "../../actions/DoctorForm.action";

function useDoctorDashboard() {
  const [rewardData, setRewardData] = useState({});
  const [cityData, setCityData] = useState([]);
  const [dropData, setDropData] = useState([]);
  const [medicineRefill, setMedicineRefill] = useState([]);
  const [medReminder, setMedReminder] = useState([]);
  const [DocTable, setDocTable] = useState([]);
  const [doctorList, setDoctorList] = useState([]);
  const [sortTable, setSortTable] = useState("top10");
  const [formValues, setFormValues] = useState({});
  const dispatch = useDispatch();
  const [expandedView, setExpandedView] = useState({
    open: false,
    title: "",
    content: null,
  });
  const { user } = useSelector((state) => state.auth);

  const form = useSelector((state) => state.doctor_form);
  const {
    user: { client_ids },
  } = useSelector((state) => state.auth);

  useEffect(() => {
    if (client_ids) {
      changeTextData(client_ids[0], "client_id");
    }
  }, [client_ids]);

  console.log("client_ids", client_ids);
  const changeTextData = useCallback(
    (text, fieldName, docList) => {
      const updatedForm = { ...form };
      if (fieldName === "doctor_ids") {
        updatedForm[fieldName] = text;
        setDoctorList(docList);
      } else if (fieldName === "client_id") {
        updatedForm["program_ids"] = [];
        // updatedForm["doctor_ids"] = [];
        updatedForm[fieldName] = text;
      } else if (fieldName === "program_ids") {
        // updatedForm["doctor_ids"] = [];
        updatedForm[fieldName] = text;
      } else if (fieldName === "start_date" || fieldName === "end_date") {
        const selectedDate = new Date(text);
        if (fieldName === "end_date") {
          const today = new Date();
          today.setHours(23, 59, 59, 999);
          if (selectedDate > today) {
            SnackbarUtils.error("End date should not be greater than today");
            updatedForm["end_date"] = "";
          } else {
            updatedForm[fieldName] = selectedDate;
          }
        } else {
          updatedForm[fieldName] = selectedDate;
        }
      } else {
        updatedForm[fieldName] = text;
      }
      if (updatedForm?.start_date && updatedForm?.end_date) {
        const startDate = new Date(updatedForm?.start_date);
        const endDate = new Date(updatedForm?.end_date);
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);
        if (startDate.getTime() > endDate.getTime()) {
          SnackbarUtils.error("End Date cannot be less than Start Date");
          updatedForm["end_date"] = "";
        }
      }

      dispatch(updateForm(updatedForm));
    },
    [form, dispatch]
  );

  const sortDocTable = useCallback(
    (val) => {
      setSortTable(val);
    },
    [sortTable]
  );

  const isFormComplete = useCallback(() => {
    return Object.entries(form).every(([key, value]) =>
      Array.isArray(value) ? value.length > 0 : Boolean(value)
    );
  }, [form]);

  const renderTotalReward = useCallback(
    (data) => {
      let req = serviceGetDoctorDashboardReward({
        ...data,
      });
      req.then((res) => {
        if (!res?.error) {
          const data = res?.data;
          setRewardData(data);
        }
      });
    },
    [setRewardData]
  );

  const renderDocTable = useCallback(
    (data) => {
      let req = serviceGetDoctorDashboardTable({
        ...data,
      });
      req.then((res) => {
        if (!res?.error) {
          const data = res?.data || {};
          setDocTable(data);
        }
      });
    },
    [setDocTable, sortTable, setSortTable]
  );

  const renderDropInfo = useCallback(
    (data) => {
      let req = serviceGetDoctorDashboardDrop({
        ...data,
      });
      req.then((res) => {
        if (!res?.error) {
          const dataAvailable = res?.data
            // ?.filter((val) => val?.is_data_available)
            ?.map((val) => ({
              label: val?.label,
              dropout: val?.dropout,
              enrollment: val?.enrollment,
              // is_data_available: val?.is_data_available,
            }));
          setDropData(dataAvailable);
        }
      });
    },
    [setDropData]
  );

  const groupedByDocData = useMemo(() => {
    if (!Array.isArray(dropData)) return {};

    return dropData.reduce((acc, { label, dropout, enrollment }) => {
      acc.label = acc?.label || [];
      acc.inactive = acc?.inactive || [];
      acc.active = acc?.active || [];

      acc.label.push(label);
      acc.inactive.push(dropout);
      acc.active.push(enrollment);

      return acc;
    }, {});
  }, [dropData]);

  const renderMedicineRefill = useCallback(
    (data) => {
      let req = serviceGetDoctorDashboardMedicineRefill({
        ...data,
      });
      req.then((res) => {
        if (!res?.error) {
          const data = res?.data;
          const result = data?.map((val) => {
            return {
              label: val?.label,
              consumption_count: val?.consumption_count,
              refill_count: val?.refill_count,
            };
          });
          setMedicineRefill(result);
        }
      });
    },
    [setMedicineRefill]
  );

  const renderMedReminder = useCallback(
    (data) => {
      let req = serviceGetDoctorDashboardMedReminder({
        ...data,
      });
      req.then((res) => {
        if (!res?.error) {
          const data = res?.data || [];
          const updatedData = data?.map((val) => {
            return {
              label: val?.label,
              COMPLETED: val?.COMPLETED,
              SKIPPED: val?.SKIPPED,
              SCHEDULED: val?.PENDING,
            };
          });
          setMedReminder(updatedData);
        }
      });
    },
    [setMedReminder]
  );

  const isAllDocSelected = useMemo(() => {
    return (
      form?.doctor_ids?.some?.((val) => val?.id === "ALL_DOCTORS") || false
    );
  }, [form]);

  useEffect(() => {
    if (isFormComplete()) {
      const updatedForm = {};

      for (const key in form) {
        const value = form[key];
        if (key === "program_ids") {
          updatedForm[key] = Array.isArray(value)
            ? value?.map((val) => val?.id)
            : [];
        } else if (["doctor_ids"].includes(key)) {
          const ids = Array.isArray(value) ? value.map((val) => val?.id) : [];
          updatedForm[key] = ids?.includes("ALL_DOCTORS")
            ? doctorList
                ?.filter(({ id }) => id !== "ALL_DOCTORS")
                ?.map(({ id }) => id)
            : ids;
        } else if (key === "client_id") {
        } else if (["start_date", "end_date"]?.includes(key)) {
          updatedForm[key] = value ? moment(value)?.format("YYYY-MM-DD") : "";
        } else {
          updatedForm[key] = value ?? "";
        }
      }
      setFormValues(updatedForm);
      renderTotalReward(updatedForm);
      renderDropInfo(updatedForm);
      renderMedicineRefill(updatedForm);
      renderMedReminder(updatedForm);
      if (isAllDocSelected) {
        renderDocTable(updatedForm);
      }
    }
  }, [form]);

  const handleDetail = useCallback((data) => {
    history.push(RouteName.PROGRAM_DETAIL + data?.id);
  }, []);

  const groupedData = useMemo(() => {
    return dropData?.reduce((acc, item) => {
      Object?.keys(item)?.forEach((key) => {
        if (!acc[key]) acc[key] = [];
        acc[key]?.push(item[key]);
      });
      return acc;
    }, {});
  }, [dropData]);

  const handleReset = useCallback(() => {
    dispatch(resetForm());
    setRewardData({});
    setCityData([]);
    setDropData([]);
    setMedicineRefill([]);
    setMedReminder([]);
    setDocTable([]);
  }, []);

  const handleExpand = useCallback((title, component) => {
    setExpandedView({
      open: true,
      title,
      content: component,
    });
  }, []);

  const downloadBlob = useCallback((blob, fileName) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }, []);

  const handleDoctorEnrollExport = useCallback(() => {
    try {
      serviceDoctorEnrollTrendExport({ ...formValues }, user?.token).then(
        async (res) => {
          const blob = await res.blob();
          downloadBlob(blob, "doctor_performance_report.csv");
        }
      );
    } catch (e) {
      console.log("error", e);
    }
  }, [formValues]);

  const handleMedicineTrendExport = useCallback(() => {
    try {
      serviceDoctorMedicineTrendExport({ ...formValues }, user?.token).then(
        async (res) => {
          const blob = await res.blob();
          downloadBlob(blob, "doctor_performance_report.csv");
        }
      );
    } catch (e) {
      console.log("error", e);
    }
  }, [formValues]);

  return {
    form,
    changeTextData,
    rewardData,
    cityData,
    dropData,
    handleDetail,
    medicineRefill,
    medReminder,
    DocTable,
    groupedData,
    handleReset,
    sortDocTable,
    sortTable,
    groupedByDocData,
    isAllDocSelected,
    setExpandedView,
    expandedView,
    handleExpand,
    handleMedicineTrendExport,
    handleDoctorEnrollExport,
  };
}

export default useDoctorDashboard;
